import React, { useState } from "react";
import { Tab, Tabs, TabPanel, TabList } from "react-tabs";
import isGHMC from "../../../../Common/helper/helpar";
import { CircleWiseSATsReports } from "./CircleWiseSATsReports/CircleWiseSATsReports";
import { ZoneWiseSATsReports } from "./ZoneWiseSATsReports/ZoneWiseSATsReports";

const TripTSSCTP = () => {
  const currentTab = localStorage.getItem("sat-trips-active-tab");
  const [selectedTab, setSelectedTab] = useState(currentTab || 0)
  const isProd = isGHMC();
  const zoneTabClassNames = `datatable_tabs ${isProd ? selectedTab == 0 ? "active-ghmc" : "active-swm" : selectedTab == 0 ? "active-default" : "inactive-default"}`
  const circleTabClassNames = `datatable_tabs ${isProd ? selectedTab == 1 ? "active-ghmc" : "active-swm" : selectedTab == 1 ? "active-default" : "inactive-default"}`
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 class="text-start mb-3">SATs Trip to TS/SCTP</h4>
            <div className="page-header">
              <div className="card">
                <div className="card-body">
                  <Tabs
                    defaultIndex={currentTab}
                    onSelect={(index) => {setSelectedTab(index); localStorage.setItem("sat-trips-active-tab", index)}}
                  >
                    <TabList style={{ display: "flex" }}>
                      <Tab className={zoneTabClassNames}>
                        Zone Wise SATs Trips to TS/SCTP
                      </Tab>
                      <Tab className={circleTabClassNames}>
                        Circle Wise SATs Trips to TS/SCTP
                      </Tab>
                    </TabList>
                    <TabPanel>
                      <ZoneWiseSATsReports />
                    </TabPanel>
                    <TabPanel>
                      <CircleWiseSATsReports />
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TripTSSCTP;
